// extracted by mini-css-extract-plugin
export default {"status":"status-YMqu","icon":"icon-WweH","active":"active-Z2k0","payment_failed":"payment_failed-qVUN","canceled":"canceled-iolK"};